import { ContentCardProps, ContentType } from 'learning-panel-components';
import { calcCourseProgress } from 'learningPanelUtils';
import { coreService } from 'network-utils';

const convertCourseToContentCard = (
    course: coreService.Course,
    isLeanUser: boolean,
    setCertificateCourseUuid: Function,
    setIsCustomCourse: Function
): ContentCardProps => {
    return {
        uuid: course.uuid,
        type: 'course' as keyof typeof ContentType,
        imageUrl: course.iconUrl ? course.iconUrl : `${process.env.PUBLIC_URL}/images/courseDefaultCard.svg`,
        name: course.name,
        displayName: course.displayName,
        tagline: course.tagline,
        cardUrl: `/app/course?courseUuid=${course.uuid}`,
        useOverlay: Boolean(course.iconUrl),
        timeOrDate: String(course.totalDuration),
        count: course.numberOfLessons,
        status: calcCourseProgress(course),
        isLeanDisabled: isLeanUser && !course.activeOnLean,
        onCompletionCertificateClick: () => {
            setCertificateCourseUuid(course.uuid);
            setIsCustomCourse(!course.isSystem);
        },
        dueDate: course.dueDate ? new Date(course.dueDate) : undefined,
        hasCertificate: course.hasCertificate,
        description: course.description,
        tags: course?.tags?.map(tag => tag.displayName)
    };
};

export default convertCourseToContentCard;
